// extracted by mini-css-extract-plugin
export default {"container":"domryW","text":"YRnjnX","block":"fazNtS"};